import TabInspectionsByCustomer from './TabInspectionsByCustomer';

export default TabInspectionsByCustomer;
